/**
 * "Refine by topic" trigger for the keyword drawer (concept §10.4). It shows
 * the number of selected keywords and is hidden while the drawer is open.
 */

import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

interface RefineByTopicButtonProps {
  selectedCount: number;
  onClick: () => void;
}

export function RefineByTopicButton({ selectedCount, onClick }: RefineByTopicButtonProps) {
  const { t } = useTranslation('search');
  const active = selectedCount > 0;
  return (
    <Button
      variant={active ? 'contained' : 'outlined'}
      color="primary"
      size="small"
      onClick={onClick}
      // Sized like the filter chips it sits next to (theme buttons have 10px 24px padding).
      sx={{ textTransform: 'none', whiteSpace: 'nowrap', height: 32, py: 0, px: 2 }}
    >
      {active ? t('topics.refineCount', { count: selectedCount }) : t('topics.refine')}
    </Button>
  );
}
